<template>
    <div >
        <div class="row no-gutters body">
            <div class="col-12 pb-5 mb-4" v-if="pageloader">
                <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
            </div>
            <div class="col-12 pb-5 mb-4" v-if="!pageloader">
                <div class="row no-gutters">
                    <div class="col-lg-3 middle-background"></div>
                    <div class="col-md-12 col-lg-6 middle-background">
                        <div class="row">
                            <br />
                        </div>
                        <div class=" no-gutters mt-5 "  >
                            <div class="col-lg-11"> 
                                <div class="row">
                                    <br />
                                </div>
                                <div>
                                    <p class="font20-bold ml-3">Who viewed my video profile?</p>
                                </div>
                                <div class="viewcard ml-3 d-flex justify-content-between">
                                    <div class="d-flex">
                                        <div class="d-flex pl-3 pr-3 trendingg">
                                            <!-- <p class="viewcount mt-1">07</p> -->
                                            <p class="ml-1  fittocenter font12-boldopacity">TRENDING</p>
                                        </div>
                                        <div class="d-flex ml-lg-3 ">
                                            <p class="fittocenter viewcount">{{totalProfilevideoViews}}</p>
                                            <p class="ml-1  fittocenter font12-boldopacity">Profile video Viewers in last 90 days</p>
                                        </div>
                                    </div>
                                    <!-- <div class="d-flex p-2">
                                        <div class="vline"></div>
                                        <div class="d-flex">
                                            <p class="pl-2 pr-2 font12redless">-82.34%</p>
                                        </div>
                                        <div class="d-flex">
                                            <p class="pl-2 pr-2 font12redincrease">+18%</p>
                                        </div>
                                    </div> -->
                                </div>
                                <nav class="nav card-header1 d-flex justify-content-between mobviewItems  ml-3 mt-4" id="nav">
                                    <div class="font12-boldcolor">
                                        <div class=" no-gutters">
                                            <ul class="nav nav-tabs p-1">
                                                <li class="nav-item" > 
                                                    <a href="#" 
                                                    class="navitem"
                                                    :class="{'list-text-color border-tab':activeClass == 'people'}"
                                                    id="people"                                                            
                                                    >All Viewers</a>
                                                </li>
                                                <div class="verticaline mt-1 mr-2"> | </div>
                                                <li class="nav-item d-flex" > 
                                                    <img src="../assets/Company_Icon.svg" class="navicon" alt="companyicon">
                                                    <a href="#" 
                                                    class="navitem"
                                                    :class="{'list-text-color border-tab':activeClass == 'company'}"
                                                    id="company"                                                            
                                                    >Company Name</a>
                                                </li>
                                                <div class="verticaline mt-1 mr-2"> | </div>
                                                <li class="nav-item d-flex"> 
                                                    <img src="../assets/Company_Icon.svg" class="navicon" alt="companyicon">
                                                    <a href="#" 
                                                    class="navitem"
                                                    :class="{'list-text-color border-tab':activeClass == 'job'}"
                                                    id="job"                                                            
                                                    >Group Name</a>
                                                </li>
                                                <div class="verticaline mt-1 mr-2"> | </div>
                                                <li class="nav-item d-flex"> 
                                                    <img src="../assets/Company_Icon.svg" class="navicon" alt="companyicon">
                                                    <a href="#" 
                                                    class="navitem"
                                                    :class="{'list-text-color border-tab':activeClass == 'product'}"
                                                    id="product"                                                            
                                                    >Who work's at Syntrino</a>
                                                </li>        
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </div>
                        <div class="col-lg-11 col-md-12 viewercards row no-gutters ml-1 mt-4" v-if="profilevideoViews !== null">
                            <div class="col-6" v-for="(record, index) in profilevideoViews" :key="index">
                                <div class="card p-3 ml-2 mb-2 text-center" >
                                    <div class="mt-2">
                                        <img src="../assets/AddProfile.svg" alt="add" class="viewprofimg" v-if="!record.prfpiclink">
                                        <img v-else class="viewprofimg" :src="record.prfpiclink" alt="">
                                    </div>
                                    <div class="d-flex flex-column">
                                        <span class="very-low p-1">{{record.fulname}}</span>
                                        <span class="font12reg">{{record.rlenme}}</span>
                                        <span class="opacityfont-12">{{record.compname}}, {{record.citynme}}, {{record.countrynme}}</span>
                                    </div>
                                    <div class="mt-3">
                                        <p class="addphoto">Found you in via WORKNOTION search</p>
                                    </div>
                                    <div class="p-2">
                                        <p class="font12-bold">{{new Date(record.createdatetimestamp) | moment("from", "now", true)}}</p>
                                    </div>
                                    <div class="mb-2">
                                        <button type="button" v-if="record.followflag == 'N'" class="btn followbtn mouseoverbtn2 backgroundcolor3 borderradius20 white font16-opacity80 bold" @click="followUser(record.profid, index)">Follow</button>
                                        <button type="button" v-if="record.followflag == 'Y'" class="btn followbtn mouseoverbtn2 backgroundcolor3 borderradius20 font16-opacity80 bold" @click="unfollowUser(record.profid, index)">UnFollow</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" v-if="!trailAccounttype && premiumcardList.length>0">
                                <div class="card premium p-3 ml-2 mb-2 text-center">
                                    <div class="mt-2">
                                        <img src="../assets/AddProfile.svg" alt="add" class="viewprofimg">
                                    </div>
                                    <div class="d-flex flex-column">
                                        <span class="very-low">Unlock your profile views with <br> Premium account</span>
                                    </div>
                                    <div class="d-flex premiumuserimg text-center mt-1">
                                        <span v-for="(prem, index) in premiumcardList" :key="index">
                                            <img :src="prem.prfpiclink" id="followImage" class="rounded-circle" alt="profilepic">
                                        </span>
                                        <div class="blackcircle rounded-circle" v-if="remainingCount>0">
                                            <span class="premiumcount" alt="">+{{remainingCount}}</span>
                                        </div>
                                       
                                    </div>
                                    <div class="mt-2 p-2 pb-1">
                                        <p class="addphoto">Pavan N, Jacobe mair, Nihar Jan and more…</p>
                                    </div>
                                    <div class="mb-2">
                                        <button type="button" class="btn followbtn borderradius20 backgroundcolorblack white font16-opacity80 sign-in-button bold" @click="TryPremium">Try Premium</button>
                                    </div>
                                    <div class="mt-1">
                                        <p class="addphoto">Free for a month</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-11 col-md-12 viewercards row no-gutters ml-1 mt-4" v-else>
                            <div class="card col-12 ml-2" >
                                <div class="card-body text-center pt-5 pb-5">
                                    <div class="p-5 d-flex flex-column text-center">
                                        <img src="../assets/no_video.svg" alt="novideo" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4">
                                        <span class="oopsnext">No Records Found</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col middle-background ">
                        <div class="row no-gutters">
                            <br />
                        </div>
                        <div class="row row no-gutters">
                            <br />
                        </div>
                        <pendingActivities />
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
import pendingActivities from "../components/PendingActivities.vue";
import httpuserprofile from "../js/http-userprofile.js"
import router from '../router';
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
        pendingActivities,
    },
    watch: {

    },
    data(){
        return {
            activeClass : 'people',
            currentUser : null,
            currentUserId : null,
            currentUserProfileId : null,
            currentUservideoProfileId : null,
            profilevideoViews : [],
            premiumcardList : [],
            remainingCount : 0,
            totalProfilevideoViews : 0,
            trailAccounttype : false,
            pageloader : true,
        }
    },
    
    methods: {
        // fetching user profile video views
        getProfileVideoViews : function() {
            httpuserprofile.get('/userprofile/listOfVideoViewers?profileId='+this.currentUserProfileId+'&limit=&videoprofileId='+this.currentUservideoProfileId)
            .then((response) => {
                console.log(response)
                if(response.data.totalRecordsFound > 6 && response.data.totalRecordsFound > response.data.list.length) {
                    console.log("none of the selecetd")
                    let instance = response.data.list;
                    for(var i = 0; i < instance.length; i++) {
                        if(i < 3){
                            this.profilevideoViews.push(instance[i])
                        }else{
                            if(i>=3 && i < 6){
                                this.premiumcardList.push(instance[i])
                                this.remainingCount = response.data.totalRecordsFound - 6
                            }
                        }
                    }
                }else{
                    console.log("in trail/premium verison")
                    this.trailAccounttype = true;
                    this.profilevideoViews = response.data.list
                }
                this.totalProfilevideoViews = response.data.totalRecordsFound
                this.pageloader = false;
            }).catch((e) => {
                console.log(e)
                this.pageloader = false
            })
        },
        // get current user details
        getcurrentUser(){
            httpuserprofile
                .get("/userprofile/userbyid/" + this.currentUserId)
                .then(response => {
                    this.currentUser = response.data;
                    this.currentUserProfileId = response.data.profileId;
                    this.currentUservideoProfileId = response.data.profileVideoId
                    this.getProfileVideoViews()
                    // this.getPemiumData()
                }).catch((e) => {
                console.log(e)
            })
        },
        // getPemiumData  :function() {
        //     httpuserprofile.post("/userprofile/getPremiumData?profileId="+this.currentUserProfileId)
        //     .then(response => {
        //         console.log("premium data :", response)
        //     }).catch((e) => {
        //         console.log(e)
        //     })
        // },
        // follow user
        followUser : function(profId, index) {
            httpuserprofile.post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+profId)
            .then(response => {
                console.log(response)
                this.profilevideoViews[index].followflag = 'Y'
            }).catch((e) => {
                console.log(e)
            })
        },
        //unfollow user
        unfollowUser : function(profId, index) {
            httpuserprofile.delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+profId)
            .then(response => {
                console.log(response)
                this.profilevideoViews[index].followflag = 'N'
            }).catch((e) => {
                console.log(e)
            })
        },
        // naviagte user to plan selection screen
        TryPremium : function() {
            router.push({
                name : 'Premium'
            })
        }
    },
    created(){        
        window.scrollTo(0, 0);
        this.currentUserId = sessionUtils.getUserId();
        this.getcurrentUser()
    },
    destroyed() {
    }
}
</script>
<style scoped>
html,
body,
.grid {
    height: 100%;
    width: 100%;
}

.viewercards{
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.header {
    position: fixed;
    width: 100%;
    z-index: 10;
    background: #ffffff;
    border-bottom: 2px solid rgba(219, 219, 219,1);
}
.nav-tabs {
    border-bottom: none !important;
}
.card-header {
    padding: 5px 10px 5px 10px;
    margin-bottom: 0;
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.premiumuserimg{
    margin: 0 auto;
}
.card-header1 {
    border: 1px solid #d9dce1;
    opacity: 0.6;
    border-radius: 8px;
}
.nav{
    background-color: #f0f2f5  !important; 
    border-radius: 8px !important;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.navbar {
    padding: 0px 0px 0px 0px !important;
    z-index: 100;
}
.nav{
    flex-wrap: unset !important;
}
.list-text-color {
    color: #0078ff;
    /* font-family: "Proxima Nova"  !important; */
    /* font-size: 16px; */
    font-weight: bold;
    letter-spacing: 0;
    white-space: nowrap;
}
.navitem{
    white-space: nowrap;
}
.no-video {
    width: 50%;
    align-self: center;
  }
.border-tab {
    border-bottom-style: solid;
    border-bottom-color: #0078ff;
    margin-left: 10px;
    margin-right: 10px;
}
#followImage{
    width: 30px;
    height: 30px;
    transform: scale(1.2)  !important;
    border: 1px solid #1F1F1F;
}
.blackcircle{
    background: black;
    color: white;
    transform: scale(1.2)  !important;
    width: 30px !important;
    height: 30px !important;
}
.premiumcount{
    font-size: 10px;
}
input:focus,
textarea:focus {
    outline: none; /** For Safari, etc **/
    border: transparent;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.premium {
    border: 1px solid #FF7676;
}
.viewcard {
  border: 1px solid #dddfe5;
  border-radius: 5px;
  background-color: #ffffff;
}
.trendingg {
    background-color: #D9DCE1;
    margin-bottom: -1px;
    border-radius: 4px 0 0 5px;
}
.fittocenter {
    margin: auto;
}
.vline {
    border-left: 1px solid #dddfe5;
    margin-top: 5px;
    margin-bottom: 5px;
}
.navicon {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: auto;
}
nav ul li a {
    padding: 0.5rem .5rem;
}
.followbtn {
    border: none;
    background-color: rgba(31, 31, 31,.04);
}
.viewprofimg {
    width: 70px;
    height: 70px;
    border: 2px solid grey;
    border-radius: 50%;
}
.mobviewItems {
    overflow-x: auto;
}
@media only screen and (max-width: 600px) {
 #followImage{
        width: 18px;
        height: 18px;
    }
}
@media screen and (min-width: 300px) and (max-width: 400px) {    
   
}
@media screen and (min-width: 350px) and (max-width: 400px) {
    nav ul li a {
        display: block;
        padding: 0.5rem 0.8rem !important;
        color: grey;
        text-decoration: none;
        display: block;
        flex: 0 1 auto;
        list-style-type: none;
        /* background: #fafafa; */
        font-size: 10px;
        max-width: 200px;
    }
    #followImage{
        width: 15px;
        height: 15px;
        transform: scale(1.6)  !important;
    /* border: 1px solid black; */
    }
}
@media screen and (min-width: 300px) and (max-width: 400px) {
    nav ul li a{
        padding: 0.5rem 0.5rem;
    }
}

@media screen and (min-width: 900px) and (max-width: 1100px) {
    
}
@media screen and (min-width: 900px) and (max-width: 1295px) {
    #followImage{
        width: 25px;
        height: 25px;
        transform: scale(1.2)  !important;
        border: 1px solid #1F1F1F;
    }   
}
</style>
